import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import type {RootState} from './store';
import {verifyOtp} from '../api/otp.api';

// // Define a type for the slice state

interface otpState {
  access_token: string;
  loading: boolean;
  error: string;
}

// Define the initial state using that type
const initialState: otpState = {
  access_token: '',
  loading: false,
  error: '',
};

interface otpVerficationData {
  token: string;
  mobileNum: string;
  code: string;
}
export const checkOtp = createAsyncThunk(
  'verifyOtp',
  async (payload: otpVerficationData, thunkApi) => {
    return verifyOtp(payload)
      .then(response => {
        //console.log(response);
        return response;
      })
      .catch(error => {
        return thunkApi.rejectWithValue(error.response.data);
      });
  },
);
export const otpVerifySlice = createSlice({
  name: 'verifyOtp',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    resetState: () => initialState,
  },
  extraReducers: builder => {
    builder.addCase(checkOtp.pending, state => {
      state.loading = true;
      state.error = '';
    });
    builder.addCase(checkOtp.fulfilled, (state, action) => {
      state.loading = false;
      state.access_token = action.payload.access_token;
    });
    builder.addCase(checkOtp.rejected, (state, action) => {
      console.log('action====>', action);
      state.error = action.toString();

      state.loading = false;
    });
  },
});
export const {resetState} = otpVerifySlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const otpAccessToken = (state: RootState): string =>
  state.otpVerifySlice.access_token;
export const errorInOtpVerification = (state: RootState): string =>
  state.otpVerifySlice.error;
export const otpVerificationIsloading = (state: RootState): boolean =>
  state.otpVerifySlice.loading;

export default otpVerifySlice.reducer;
